import DOMPurify from 'dompurify';
import parse from 'html-react-parser';

export enum LoadStatus {
   idle = 'idle',
   loading = 'loading',
   failed = 'failed',
   complete = 'complete',
}

export const Common = {
   renderHtml: (data: string | undefined) => {
      if (!data) return '';
      const sanitizedData = DOMPurify.sanitize(data);
      return parse(sanitizedData);
   },
};

export const handleMainElementDisplay = (display: boolean) => {
   const mainElem = document.getElementById('main');
   if (mainElem) {
      mainElem.style.display = display ? 'block' : 'none';
   }
};

export const handleFooterElementDisplay = (display: boolean) => {
   const mainElem = document.getElementById('footer');
   if (mainElem) {
      mainElem.style.display = display ? 'block' : 'none';
   }

   const wrapperElems = document.getElementsByClassName('footer-wrapper');
   if (wrapperElems && wrapperElems.length > 0) {
      Array.from(wrapperElems).forEach((elem) => {
         (elem as HTMLElement).style.display = display ? 'block' : 'none';
      });
   }
};

export const stripeSandboxPublishableKey =
   'pk_test_51QxRqeDAaViTlcvYicz3lye326pkvC6Jcu8QfXDBVURQ1OUoVJ4DmtBVJN8gSabJPiZ77BUseTQVMuGfayq5B9Me00vhsSpdsT';

export const stripePublishableKey =
   'pk_live_51QxRqXDh8pPb6sQ6NNW3etlgjiDtN0jJsTG8zKlF00FBkOsePPvY5mEqUp724bT3XEJrr0IhGgr06J7lSgi4vCw700hCjfAyzb';
